<template>
    <div :class="'uk-child-width-1-'+ size + '@m'" uk-grid>
        <div v-for="i in images">
            <img :src="i.url" :alt="i.alt" :title="i.title" /> 
        </div>
    </div>
</template>
<script>
export default {
    name:"VueImage",
    props: {
        img: {
            required: true
        },
        size: {
            required: false,
            default: 2
        }
    },
    computed: {
        images () {
            if(this.img) {
                if(this.img.key) {
                    var res = {}
                    res[this.img.key] = this.img
                    return res
                } else {
                    return this.img
                }
            } else {
                return null
            }
            
        }
    }
}
</script>


// WEBPACK FOOTER //
// VueImage.vue?c8089ae8